import React from "react";
import { Box, Typography } from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import css from "./dateinput.module.scss";

export interface DateInputProps {
  label: string;
  placeholder?: string;
  initialValue: string;
  updateValue: (value: string) => void;
  isRequired?: boolean;
  dateFormat?: string;
  showYearDropdown?: boolean;
  scrollableYearDropdown?: boolean;
  yearDropdownItemNumber?: number;
}

const DateInput: React.FC<DateInputProps> = ({
  label,
  placeholder = "YYYY-MM-DD",
  initialValue,
  updateValue,
  isRequired = false,
  dateFormat = "yyyy-MM-dd",
  showYearDropdown = true,
  scrollableYearDropdown = true,
  yearDropdownItemNumber = 100,
}) => {
  const handleDateChange = (date: Date | null) => {
    updateValue(date ? date.toISOString().split("T")[0] : "");
  };

  return (
    <Box>
      <Typography variant="body2" sx={{ mb: 1 }}>
        {label}
        {isRequired && <span style={{ color: "#d32f2f" }}>*</span>}
      </Typography>
      <div className={css.datePickerWrapper}>
        <DatePicker
          selected={initialValue ? new Date(initialValue) : null}
          onChange={handleDateChange}
          placeholderText={placeholder}
          dateFormat={dateFormat}
          showYearDropdown={showYearDropdown}
          scrollableYearDropdown={scrollableYearDropdown}
          yearDropdownItemNumber={yearDropdownItemNumber}
          onChangeRaw={(e) => e?.preventDefault()}
        />
      </div>
    </Box>
  );
};

export default DateInput;
